export default {
  Common: {
    CancelRequest: 'Cancel Request'
  }
}
